
export function SETUSERLIST(state, val) {
    state.userList = val
}
